import SystemSettingsApi from '../api/SystemSettingsApi';

/**
 * Cached multi-currency flags from system_settings (singleton row).
 * When multi_currency_enabled is false, UI should not show base equivalents or exchange-rate UX;
 * backend forces record currency to company_currency on save.
 */
let cached = null;
let inflight = null;

export function clearMultiCurrencySettingsCache() {
  cached = null;
  inflight = null;
}

function parseMultiFromSettingsArray(arr) {
  const list = Array.isArray(arr) ? arr : [];
  const companyItem = list.find((s) => s && s.key === 'company_currency');
  const multiItem = list.find((s) => s && s.key === 'multi_currency_enabled');
  const inlineEditItem = list.find((s) => s && s.key === 'enable_inline_editing');
  const openParentItem = list.find((s) => s && s.key === 'open_parent_in_modal');

  const companyCurrency =
    companyItem != null && companyItem.value != null
      ? String(companyItem.value).trim()
      : '';

  const rawMulti = multiItem?.value;
  const multiCurrencyEnabled =
    rawMulti === true || String(rawMulti).toLowerCase() === 'true';

  const rawInline = inlineEditItem?.value;
  const enableInlineEditing =
    rawInline === undefined || rawInline === true || String(rawInline).toLowerCase() === 'true';

  const rawOpenParent = openParentItem?.value;
  const openParentInModal =
    rawOpenParent === true || String(rawOpenParent).toLowerCase() === 'true';

  return { multiCurrencyEnabled, companyCurrency, enableInlineEditing, openParentInModal };
}

/**
 * @returns {Promise<{ multiCurrencyEnabled: boolean, companyCurrency: string, enableInlineEditing: boolean, openParentInModal: boolean }>}
 */
export async function getMultiCurrencySettings() {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const api = new SystemSettingsApi();
      const res = await api.fetchSettings();
      const data = res?.data;
      const arr = data?.success && Array.isArray(data.data) ? data.data : [];
      cached = parseMultiFromSettingsArray(arr);
      return cached;
    } catch (e) {
      console.warn('getMultiCurrencySettings failed:', e?.message);
      // Fail open: assume multi-currency on so we do not strip conversion UX on transient errors
      cached = { multiCurrencyEnabled: true, companyCurrency: '', enableInlineEditing: true, openParentInModal: false };
      return cached;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}
